enum InsuredCountry {
  "THAILAND" = "TH",
  "CAMBODIA" = "KH",
  "INDONESIA" = "ID",
  "VIETNAM" = "VI",
  "JAPAN" = "JP",
  "PHILIPPINES" = "PH",
}

const INSURANCE_FEATURE_FLAGS = {
  ID: {
    services: {
      Cancellation: true,
      CancellationOpus: false,
      CancellationV2: true,
      CashValueLoan: false,
      CashValueLoanOpus: false,
      ChangeAddress: true,
      ChangeAddressOpus: false,
      ChangeBeneficiary: true,
      ChangeBeneficiaryV2: true,
      ChangeBeneficiaryV3: true,
      ChangeName: true,
      ChangeNameOpus: false,
      ChangeProfile: true,
      ChangeProfileOpus: false,
      ChequeCancellation: false,
      Claim: true,
      DeductionCertificate: false,
      DeleteRider: true,
      DeleteRiderOpus: false,
      EDocuments: false,
      FundAllocate: false,
      FundSwitch: true,
      FundSwitchOpus: false,
      ICP: false,
      ICPOpus: false,
      IncreaseSumAssured: false,
      LoanRepayment: false,
      ManagePolicy: true,
      MyPolicies: true,
      MyTransactions: true,
      PartialWithdrawal: true,
      PartialWithdrawalOpus: false,
      PartialWithdrawalV2: true,
      PaymentFrequency: true,
      PaymentFrequencyV2: true,
      PaymentHistory: false,
      PremiumHoliday: true,
      RecurringPayment: false,
      RecurringPaymentOpus: false,
      RecurringPaymentV2: false,
      RegularTopUp: false,
      Reinstatement: false,
      ReissuePolicyCertificate: false,
      RenewalPremium: true,
      RenewalPremiumQR: false,
      RiskProfile: false,
      RiskProfileOpus: false,
      SettlementAccount: false,
      SingleTopUp: true,
      Surrender: true,
      SurrenderOpus: false,
      TaxConsent: false,
      TaxConsentOpus: false,
      IDEBEnabled: false,
      BenefitPayoutHistory: false,
      PremiumPaymentHistory: false,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: false,
      ChangeAddressEnhancement: false,
      PreferredPayout: false,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: false,
      ViewEStatement: false,
      Investments: true,
      InvestmentV2: false,
      FactSheet: false,
      HealthCard: false,
      EDocumentsV2: false,
      TaxSeasonBanner: false,
      Announcement: true,
    },
    ClaimV2: {
      enabled: true,
      ocrV2: true,
      ocrV3: false,
      isScanOCR: true,
      isShowQuickTip: false,
      isAsynchronousUpload: false,
      claimUIV3: false,
    },
    VoiceOfCustomer: { enabled: false, claims: true },
  },
  JP: {
    services: {
      Cancellation: false,
      CancellationOpus: false,
      CancellationV2: false,
      CashValueLoan: false,
      CashValueLoanOpus: false,
      ChangeAddress: true,
      ChangeAddressOpus: false,
      ChangeBeneficiary: true,
      ChangeBeneficiaryKYC: true,
      ChangeBeneficiaryV2: false,
      ChangeBeneficiaryV3: true,
      ChangeName: true,
      ChangeNameOpus: false,
      ChangeProfile: true,
      ChangeProfileOpus: false,
      ChequeCancellation: false,
      Claim: true,
      DeductionCertificate: true,
      DeleteRider: false,
      DeleteRiderOpus: false,
      EDocuments: false,
      FundAllocate: false,
      FundSwitch: false,
      FundSwitchOpus: false,
      ICP: false,
      ICPOpus: false,
      IncreaseSumAssured: false,
      LoanRepayment: false,
      ManagePolicy: true,
      MyPolicies: true,
      MyTransactions: true,
      PartialWithdrawal: false,
      PartialWithdrawalOpus: false,
      PartialWithdrawalV2: false,
      PaymentFrequency: false,
      PaymentFrequencyV2: false,
      PaymentHistory: false,
      PremiumHoliday: false,
      RecurringPayment: true,
      RecurringPaymentOpus: false,
      RecurringPaymentV2: true,
      RegularTopUp: false,
      Reinstatement: false,
      ReissuePolicyCertificate: true,
      RenewalPremium: false,
      RenewalPremiumQR: false,
      RiskProfile: false,
      RiskProfileOpus: false,
      SettlementAccount: false,
      SingleTopUp: false,
      Surrender: true,
      SurrenderOpus: false,
      TaxConsent: false,
      TaxConsentOpus: false,
      IDEBEnabled: false,
      BenefitPayoutHistory: false,
      PremiumPaymentHistory: false,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: false,
      ChangeAddressEnhancement: false,
      PreferredPayout: false,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: false,
      ViewEStatement: false,
      Investments: false,
      InvestmentV2: false,
      FactSheet: false,
      HealthCard: false,
      EDocumentsV2: false,
      TaxSeasonBanner: false,
      Announcement: true,
      isRecurringPaymentV2Phase1: true,
    },
    ClaimV2: {
      enabled: true,
      ocrV2: true,
      ocrV3: false,
      isScanOCR: true,
      isShowQuickTip: true,
      isAsynchronousUpload: false,
      claimUIV3: true,
      outpatientSTP: false,
    },
    VoiceOfCustomer: { enabled: true, claims: true },
  },
  TH: {
    services: {
      Cancellation: true,
      CancellationOpus: false,
      CancellationV2: true,
      CashValueLoan: true,
      CashValueLoanOpus: true,
      ChangeAddress: true,
      ChangeAddressOpus: true,
      ChangeBeneficiary: true,
      ChangeBeneficiaryV2: true,
      ChangeBeneficiaryV3: true,
      ChangeName: true,
      ChangeNameOpus: true,
      ChangeProfile: true,
      ChangeProfileOpus: true,
      ChequeCancellation: true,
      Claim: true,
      DeductionCertificate: false,
      DeleteRider: false,
      DeleteRiderOpus: true,
      EDocuments: true,
      FundAllocate: false,
      FundSwitch: true,
      FundSwitchOpus: true,
      ICP: true,
      ICPOpus: true,
      IncreaseSumAssured: false,
      LoanRepayment: true,
      ManagePolicy: true,
      MyPolicies: true,
      MyTransactions: true,
      PartialWithdrawal: true,
      PartialWithdrawalOpus: true,
      PartialWithdrawalV2: true,
      PaymentFrequency: true,
      PaymentFrequencyV2: true,
      PaymentHistory: false,
      PremiumHoliday: false,
      RecurringPayment: true,
      RecurringPaymentOpus: true,
      RecurringPaymentV2: true,
      RegularTopUp: false,
      Reinstatement: false,
      ReissuePolicyCertificate: false,
      RenewalPremium: true,
      RenewalPremiumQR: true,
      RiskProfile: true,
      RiskProfileOpus: true,
      SettlementAccount: false,
      SingleTopUp: false,
      Surrender: true,
      SurrenderOpus: false,
      TaxConsent: true,
      TaxConsentOpus: true,
      IDEBEnabled: false,
      BenefitPayoutHistory: true,
      PremiumPaymentHistory: true,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: true,
      ChangeAddressEnhancement: false,
      PreferredPayout: true,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: true,
      ViewEStatement: true,
      Investments: true,
      InvestmentV2: false,
      FactSheet: true,
      HealthCard: true,
      EDocumentsV2: true,
      TaxSeasonBanner: true,
      Announcement: true,
    },
    ClaimV2: {
      enabled: true,
      ocrV2: true,
      ocrV3: false,
      isScanOCR: true,
      isShowQuickTip: false,
      isAsynchronousUpload: true,
      claimUIV3: false,
    },
    VoiceOfCustomer: { enabled: true, claims: true },
  },
  KH: {
    services: {
      Cancellation: true,
      CancellationOpus: false,
      CancellationV2: true,
      CashValueLoan: false,
      CashValueLoanOpus: false,
      ChangeAddress: true,
      ChangeAddressOpus: false,
      ChangeBeneficiary: true,
      ChangeBeneficiaryV2: false,
      ChangeBeneficiaryV3: true,
      ChangeName: false,
      ChangeNameOpus: false,
      ChangeProfile: true,
      ChangeProfileOpus: false,
      ChequeCancellation: false,
      Claim: true,
      DeductionCertificate: false,
      DeleteRider: true,
      DeleteRiderOpus: false,
      EDocuments: true,
      FundAllocate: false,
      FundSwitch: false,
      FundSwitchOpus: false,
      ICP: false,
      ICPOpus: false,
      IncreaseSumAssured: true,
      LoanRepayment: false,
      ManagePolicy: true,
      MyPolicies: true,
      MyTransactions: true,
      PartialWithdrawal: false,
      PartialWithdrawalOpus: false,
      PartialWithdrawalV2: false,
      PaymentFrequency: true,
      PaymentFrequencyV2: false,
      PaymentHistory: true,
      PremiumHoliday: false,
      RecurringPayment: false,
      RecurringPaymentOpus: false,
      RecurringPaymentV2: false,
      RegularTopUp: false,
      Reinstatement: true,
      ReissuePolicyCertificate: false,
      RenewalPremium: true,
      RenewalPremiumQR: false,
      RiskProfile: false,
      RiskProfileOpus: false,
      SettlementAccount: false,
      SingleTopUp: false,
      Surrender: true,
      SurrenderOpus: false,
      TaxConsent: false,
      TaxConsentOpus: false,
      IDEBEnabled: false,
      BenefitPayoutHistory: false,
      PremiumPaymentHistory: false,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: false,
      ChangeAddressEnhancement: false,
      PreferredPayout: false,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: false,
      ViewEStatement: true,
      Investments: false,
      InvestmentV2: false,
      FactSheet: false,
      HealthCard: false,
      EDocumentsV2: false,
      TaxSeasonBanner: false,
      Announcement: true,
    },
    ClaimV2: {
      enabled: true,
      ocrV2: true,
      ocrV3: false,
      isScanOCR: false,
      isShowQuickTip: false,
      isAsynchronousUpload: false,
      claimUIV3: false,
    },
    VoiceOfCustomer: { enabled: true, claims: true },
  },
  PH: {
    services: {
      Cancellation: true,
      CancellationOpus: false,
      CancellationV2: true,
      CashValueLoan: false,
      CashValueLoanOpus: false,
      ChangeAddress: true,
      ChangeAddressOpus: false,
      ChangeBeneficiary: true,
      ChangeBeneficiaryV2: false,
      ChangeBeneficiaryV3: true,
      ChangeName: true,
      ChangeNameOpus: false,
      ChangeProfile: true,
      ChangeProfileOpus: false,
      ChequeCancellation: false,
      Claim: true,
      DeductionCertificate: false,
      DeleteRider: false,
      DeleteRiderOpus: false,
      EDocuments: true,
      FundAllocate: true,
      FundSwitch: true,
      FundSwitchOpus: false,
      ICP: false,
      ICPOpus: false,
      IncreaseSumAssured: false,
      LoanRepayment: false,
      ManagePolicy: true,
      MyPolicies: true,
      MyTransactions: true,
      PartialWithdrawal: false,
      PartialWithdrawalOpus: false,
      PartialWithdrawalV2: false,
      PaymentFrequency: true,
      PaymentFrequencyV2: true,
      PaymentHistory: true,
      PremiumHoliday: false,
      RecurringPayment: true,
      RecurringPaymentOpus: false,
      RecurringPaymentV2: true,
      RegularTopUp: false,
      Reinstatement: true,
      ReissuePolicyCertificate: false,
      RenewalPremium: true,
      RenewalPremiumQR: false,
      RiskProfile: false,
      RiskProfileOpus: false,
      SettlementAccount: true,
      SingleTopUp: true,
      Surrender: false,
      SurrenderOpus: false,
      TaxConsent: false,
      TaxConsentOpus: false,
      IDEBEnabled: false,
      BenefitPayoutHistory: false,
      PremiumPaymentHistory: false,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: false,
      ChangeAddressEnhancement: false,
      PreferredPayout: false,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: false,
      ViewEStatement: false,
      Investments: true,
      InvestmentV2: true,
      FactSheet: false,
      HealthCard: false,
      EDocumentsV2: false,
      TaxSeasonBanner: false,
      Announcement: true,
    },
    ClaimV2: {
      enabled: true,
      ocrV2: true,
      ocrV3: false,
      isScanOCR: false,
      isShowQuickTip: false,
      isAsynchronousUpload: false,
      claimUIV3: false,
    },
    VoiceOfCustomer: { enabled: true, claims: true },
  },
  VI: {
    services: {
      Cancellation: false,
      CancellationOpus: false,
      CancellationV2: false,
      CashValueLoan: false,
      CashValueLoanOpus: false,
      ChangeAddress: false,
      ChangeAddressOpus: false,
      ChangeBeneficiary: false,
      ChangeBeneficiaryV2: false,
      ChangeBeneficiaryV3: false,
      ChangeName: false,
      ChangeNameOpus: false,
      ChangeProfile: false,
      ChangeProfileOpus: false,
      ChequeCancellation: false,
      Claim: false,
      DeductionCertificate: false,
      DeleteRider: false,
      DeleteRiderOpus: false,
      EDocuments: false,
      FundAllocate: false,
      FundSwitch: false,
      FundSwitchOpus: false,
      ICP: false,
      ICPOpus: false,
      IncreaseSumAssured: false,
      LoanRepayment: false,
      ManagePolicy: false,
      MyPolicies: false,
      MyTransactions: false,
      PartialWithdrawal: false,
      PartialWithdrawalOpus: false,
      PartialWithdrawalV2: false,
      PaymentFrequency: false,
      PaymentFrequencyV2: false,
      PaymentHistory: false,
      PremiumHoliday: false,
      RecurringPayment: false,
      RecurringPaymentOpus: false,
      RecurringPaymentV2: false,
      RegularTopUp: false,
      Reinstatement: false,
      ReissuePolicyCertificate: false,
      RenewalPremium: false,
      RenewalPremiumQR: false,
      RiskProfile: false,
      RiskProfileOpus: false,
      SettlementAccount: false,
      SingleTopUp: false,
      Surrender: false,
      SurrenderOpus: false,
      TaxConsent: false,
      TaxConsentOpus: false,
      IDEBEnabled: false,
      BenefitPayoutHistory: false,
      PremiumPaymentHistory: false,
      ForceMPin: true,
      ForceBiometric: true,
      OtherRequests: false,
      ChangeAddressEnhancement: false,
      PreferredPayout: false,
      OnboardFeedback: false,
      OverallFeedback: false,
      OtpPhoneEmail: false,
    },
    viewonly: {
      EBOnboardedV2: false,
      ViewEStatement: false,
      Investments: false,
      InvestmentV2: false,
      FactSheet: false,
      HealthCard: false,
      EDocumentsV2: false,
      TaxSeasonBanner: false,
      Announcement: true,
    },
    ClaimV2: {
      enabled: false,
      ocrV2: false,
      ocrV3: false,
      isScanOCR: false,
      isShowQuickTip: false,
      isAsynchronousUpload: false,
      claimUIV3: false,
    },
    VoiceOfCustomer: { enabled: false, claims: false },
  },
};

const servicingTransactionTypes = [
  {
    key: "insurance_servicing.General_TransactionType_AddClaim",
    val: "AddClaim",
  },
  {
    key: "insurance_servicing.General_TransactionType_ChangeOfMailingAddress",
    val: "Address",
  },
  {
    key: "insurance_servicing.ChangeProfile_ChangeAddress_ChangeMailingAddress",
    val: "ChangeAddress",
  },
  {
    key: "insurance_servicing.General_TransactionType_ChangeOfBeneficiary",
    val: "ChangeBeneficiary",
  },
  {
    key: "insurance_servicing.TH_ChangeOfPreferredPayout",
    val: "ChangeICP",
  },
  {
    key: "insurance_servicing.TH_ChangeOfPreferredPayout",
    val: "ICP",
  },
  {
    key: "insurance_servicing.General_TransactionType_ChangeOfPaymentFrequency",
    val: "PaymentFrequency",
  },
  {
    key: "insurance_servicing.General_TransactionType_ChangeOfPersonalDetails",
    val: "Email",
  },
  {
    key: "insurance_servicing.General_TransactionType_DeleteRider",
    val: "DeleteRider",
  },
  {
    key: "insurance_servicing.General_TransactionType_FreelookCancellation",
    val: "Cancellation",
  },
  {
    key: "insurance_servicing.General_TransactionType_SurrenderPolicy",
    val: "Surrender",
  },
  {
    key: "insurance_servicing.General_TransactionType_PremiumHoliday",
    val: "PremiumHoliday",
  },
  {
    key: "insurance_servicing.Transaction_TransactionsServicing_ChangeOfName",
    val: "ChangeName",
  },
  {
    key: "insurance_servicing.TaxConsent_ChangeOfTaxConsent",
    val: "TaxConsent",
  },
  {
    key: "insurance_servicing.RecurringPayments_Transactions_ChangeOfRecurringPayment",
    val: "RecurringCC",
  },
  {
    key: "insurance_servicing.RecurringPayments_Transactions_ChangeOfRecurringPayment",
    val: "RecurringPayment",
  },
  {
    key: "insurance_servicing.General_TransactionType_PartialWithdrawal",
    val: "PartialWithDrawal",
  },
  {
    key: "insurance_servicing.LoanRequest_PolicyLoanRequest",
    val: "CashValueLoan",
  },
  {
    key: "insurance_servicing.General_TransactionType_ChangeOfPaymentFrequency",
    val: "ChangeFrequency",
  },
  {
    key: "insurance_servicing.Transaction_Reinstate_ReinstateLapsedPolicies",
    val: "Reinstatement",
  },
  {
    key: "insurance_servicing.General_TransactionType_FundSwitch",
    val: "FundSwitch",
  },
  {
    key: "insurance_servicing.Servicing_IncreaseSumAssured_IncreaseSumAssured",
    val: "IncreaseSumAssured",
  },
  {
    key: "insurance_servicing.Transaction_Servicing_PayRenewalPremium",
    val: "RenewalPremium",
  },
  {
    key: "insurance_servicing.Transactions_NominateSettlementAccount",
    val: "NominateSettlementAccount",
  },
  {
    key: "insurance_servicing.Transactions_NominateSettlementAccount",
    val: "SettlementAccount",
  },
  {
    key: "insurance_servicing.PremiumAllocation_UpdateAllocation_UpdatePremiumAllocation",
    val: "premiumAllocation",
  },
  {
    key: "insurance_servicing.PremiumAllocation_UpdateAllocation_UpdatePremiumAllocation",
    val: "FundAllocate",
  },
  {
    key: "insurance_servicing.ReissueOfCertificate_ReissueOfDeductionCertificate_Title",
    val: "TaxDeductionCertificate",
  },
  {
    key: "insurance_servicing.Reissue_Header_ReissueOfInsurancePolicyCertificate",
    val: "ReissuePolicyCertificate",
  },
  {
    key: "insurance_servicing.ServicingMenu_PaymentRelatedServices_SingleTopUp",
    val: "SingleTopUp",
  },
  {
    key: "insurance_servicing.CancelCheque_Title_CancelChequeJourney",
    val: "ChequeCancellation",
  },
  {
    key: "insurance_servicing.Viewpolicy_DocumentsList_InsuranceCertificate",
    val: "InsuranceCertificate",
  },
  {
    key: "insurance_servicing.ViewPolicy_PaymentHistory_PaymentHistory",
    val: "PaymentHistory",
  },
];

const claimsTransactionTypes = [
  {
    key: "insurance_servicing.General_TransactionType_AccidentBenefit",
    val: "Accident Benefit",
  },
  {
    key: "insurance_servicing.General_TransactionType_CriticalIllness",
    val: "Critical Illness",
  },
  {
    key: "insurance_claims.General_ClaimType_CriticalIllnessIncludingCancer",
    val: "Critical Illness including Cancer",
  },
  {
    key: "insurance_claims.General_ClaimType_Disability",
    val: "Disability",
  },
  {
    key: "insurance_claims.General_ClaimType_DisabilityAndDismemberment",
    val: "Disability & Dismemberment",
  },
  {
    key: "insurance_claims.General_ClaimType_Hospitalisation",
    val: "Hospitalisation",
  },
  {
    key: "insurance_claims.General_ClaimType_Hospitalisation",
    val: "Hospitalization",
  },
  {
    key: "insurance_servicing.General_TransactionType_OutpatientConsultation",
    val: "Outpatient Consultation",
  },
  {
    key: "insurance_claims.General_ClaimType_OutpatientReimbursement",
    val: "Outpatient Reimbursement",
  },
  {
    key: "insurance_claims.General_ClaimType_OutpatientSurgery",
    val: "Outpatient Surgery",
  },
  {
    key: "insurance_claims.General_ClaimType_OutpatientTreatment",
    val: "Outpatient Treatment",
  },
  {
    key: "insurance_servicing.General_TransactionType_WaiverOfPremium",
    val: "Waiver of Premium",
  },
  {
    key: "insurance_claims.General_ClaimType_Optical",
    val: "Optical",
  },
  {
    key: "insurance_claims.General_ClaimType_Dental",
    val: "Dental",
  },
  {
    key: "insurance_claims.General_ClaimType_PreventiveCare",
    val: "Preventive care",
  },
  {
    key: "insurance_claims.General_ClaimType_Maternity",
    val: "Maternity",
  },
];

const transactionTypes = [
  ...servicingTransactionTypes,
  ...claimsTransactionTypes,
];

const getCountryFlag = insuredCountry => {
  const flag = INSURANCE_FEATURE_FLAGS[insuredCountry];
  if (flag === null) {
    throw Error("Insured country not found");
  }
  return flag;
};

const checkIfFeatureEnabled = (name, type, country) => {
  const flag = getCountryFlag(country);
  return flag ? Object(flag[type])[name] : false;
};

export const getMappedRequestType = (
  requestType = "",
  insuredCountry,
): { key: string; val: string } => {
  if (
    insuredCountry === InsuredCountry.JAPAN &&
    (requestType === "Phone" || requestType === "ChangeProfile")
  ) {
    return {
      key: "insurance_servicing.Transaction_Servicing_ChangeOfMobileNumber",
      val: "Email",
    };
  }
  if (insuredCountry === InsuredCountry.JAPAN && requestType === "ChangeName") {
    return {
      key: "insurance_servicing.Transaction_TransactionsServicing_ChangeOfName",
      val: "Email",
    };
  }
  if (
    requestType === "EmailPhone" ||
    requestType === "Email" ||
    requestType === "Phone" ||
    requestType === "ChangeName" ||
    requestType === "ChangeProfile"
  ) {
    return {
      key: "insurance_servicing.General_TransactionType_ChangeOfPersonalDetails",
      val: "Email",
    };
  }
  if (
    insuredCountry === InsuredCountry.PHILIPPINES &&
    requestType === "SingleTopUp"
  ) {
    return {
      key: "insurance_servicing.Transactions_TopUp_AdHocTopUp",
      val: "SingleTopUp",
    };
  }
  //for handling Change Beneficiary design refresh
  if (
    requestType?.toLowerCase() === "ChangeBeneficiary".toLowerCase() &&
    checkIfFeatureEnabled("ChangeBeneficiaryV3", "services", insuredCountry)
  ) {
    return {
      key: "insurance_servicing.ChangeBeneficiary_ChangeOfBeneficiary(s)Details",
      val: "ChangeBeneficiary",
    };
  }
  //Overwrite if ServicingName.PreferredPayout is disabled
  if (
    (requestType?.toLowerCase() === "ICP".toLowerCase() ||
      requestType?.toLowerCase() === "ChangeICP".toLowerCase()) &&
    !checkIfFeatureEnabled("PreferredPayout", "services", insuredCountry)
  ) {
    return {
      key: "insurance_servicing.General_TransactionType_ChangeIcp",
      val: "ChangeICP",
    };
  }

  if (
    insuredCountry === InsuredCountry.JAPAN &&
    requestType === "RecurringCC" &&
    checkIfFeatureEnabled(
      "isRecurringPaymentV2Phase1",
      "viewonly",
      insuredCountry,
    )
  ) {
    return {
      key: "insurance_servicing.RecurringPayments_Transactions_ChangeOfRecurringPayment_Phase1",
      val: "RecurringCC",
    };
  }

  return (
    transactionTypes.find(
      e => (e.val || "").toLowerCase() === requestType?.toLowerCase(),
    ) || { key: "", val: "" }
  );
};
